import React, { FC, useMemo } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';
//constants
import ICONS from '../../../../../constants/icons';

//models
import { GamificationItemModel } from '../../../../../models/label.model';

interface LabelAgentIconProps {
    setAnchorEl: (event: HTMLElement) => void;
    inProgressGamificationList: GamificationItemModel[];
    isLoading?: boolean;
}
const LabelAgentIcon: FC<LabelAgentIconProps> = ({
    setAnchorEl,
    inProgressGamificationList,
    isLoading,
}) => {
    const openPopover = (event: React.MouseEvent<HTMLElement>) => {
        if (!isLoading) {
            setAnchorEl(event.currentTarget);
        }
    };

    const labelAgentIcon = useMemo<React.JSX.Element>(() => {
        const count = inProgressGamificationList.map((item) => item.count);
        const labels = count.length;
        const count2 = count.filter((i: number) => i >= 2).length;
        const count3 = count.filter((i: number) => i >= 3).length;

        if (labels === 0) return <ICONS.labelAgent07 />; // No labelled alternate
        if (labels === 1 && count[0] >= 2) return <ICONS.labelAgent05 />; // 1 labeled alternate with count >= 2
        if (labels === 1) return <ICONS.labelAgent06 />; // Exactly 1 labeled alternate
        if (labels === 2 && count2 < 2) return <ICONS.labelAgent05 />; // At least 2 labeled alternates

        if (count2 >= 2) {
            // At least 2 labels with at least 2 alternates each
            if (labels >= 5 && count3 >= 5) return <ICONS.labelAgent01 />; // 5 or more labels, all with 3 or more alternates
            if (labels >= 4 && count3 >= 3) return <ICONS.labelAgent02 />; // 4 or more labels, at least 3 labels have 3 alternates
            if (count3 === 3) return <ICONS.labelAgent03 />; // 3 labels with 3 alternates for each
            return <ICONS.labelAgent04 />; // Default: 2 labels with 2 alternates for each
        }

        return <ICONS.labelAgent05 />; // Default: At least 2 labeled alternates
    }, [inProgressGamificationList]);

    return (
        <StyledInfoIcon onClick={openPopover}>
            <StyledIcon>{labelAgentIcon}</StyledIcon>
        </StyledInfoIcon>
    );
};

const StyledIcon = styled.div({
    transform: 'rotate(0deg)',
    transition: 'transform 0.3s ease',
    '&:hover': {
        transform: 'rotate(25deg)',
    },
});

const StyledInfoIcon = styled.div({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: '39px',
    height: '39px',
    padding: aampeTheme.spacing4(2),
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.7)',
});

export default LabelAgentIcon;
